import WhyNot from '../../models/component-selector/why-not';
import { isSOIC, isSOICEP, isMSOP, isMSOPEP, isSOT23 } from '../../utils/package-checker';

export function reasonsOpampPackagingMarginal(opAmp) {
  let reasons = [];
  let packageCode = typeof opAmp.packageCode === 'string' ? opAmp.packageCode.toUpperCase() : opAmp.packageCode;
  if (packageCode) {
    if (parseFloat(opAmp.numberChannels) > 2) {
      if (parseFloat(opAmp.numberChannels) === 4) {
        reasons.push(WhyNot.create({ messageId: 'opAmpSelection.status.quad-opamp' }));
      } else {
        reasons.push(WhyNot.create({ messageId: 'opAmpSelection.status.channel-support' }));
      }
    } else if (parseFloat(opAmp.numberChannels) === 2) {
      if (!isSOIC(packageCode) && !isSOICEP(packageCode) && !isMSOP(packageCode) && !isMSOPEP(packageCode)) {
        reasons.push(WhyNot.create({ messageId: 'opAmpSelection.status.package-incompatible' }));
      }
    } else if (parseFloat(opAmp.numberChannels) === 1) {
      if (!isSOIC(packageCode) && !isSOICEP(packageCode) && !isSOT23(packageCode)) {
        reasons.push(WhyNot.create({ messageId: 'opAmpSelection.status.package-incompatible' }));
      }
    }
  } else {
    // Log Errors Here
  }
  return reasons;
}

export function applyAdditionalCriteria(opAmp) {
  const reasons = reasonsOpampPackagingMarginal(opAmp);
  return reasons.length > 0 ? 'allowed' : 'recommended';
}

// The following function flags opamps with poles that are too close to the frequency range of interest.
// Poles near the operating region can result in strange response curves.
export function polesZeroesMarginal(limits, opAmp) {
  let result = false;
  const FUDGE_FACTOR = 10;
  if ('polesZeroes' in opAmp) {
    let minPole = opAmp.polesZeroes.p.find((value) => {
      return value > 10;
    });
    result = (opAmp.rOut * FUDGE_FACTOR) / minPole > limits.rOutOverGBW;
  }
  return result;
}
